import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoMedium, mixinRobotoRegular } from '../../../../styles';

export const AddRFQStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .add-rfq-wrapper {
    display: flex;
    flex-wrap: wrap;
    height: calc(100% - 70px);
  }

  .add-rfq-wrapper > .header {
    width: 100%;
    font-size: 16px;
    color: var(--nest-level-tab-font);
    border-bottom: 1px solid var(--border-1);
    line-height: 56px;
    padding-left: 15px;
    ${mixinRobotoBold}
  }

  .vppa-details-wrapper {
    width: 250px;
    background-color: rgb(255 255 255 / 3%);
    border-right: 1px solid var(--border-1);
  }

  .vppa-details-wrapper .header {
    font-size: 14px;
    color: var(--nest-level-tab-font);
    padding: 25px 0 20px 15px;
    ${mixinRobotoMedium()}
  }

  .vppa-details-wrapper .row {
    display: flex;
    padding: 5px 15px;
    font-size: 12px;
    border-bottom: 1px solid var(--border-1);
    align-items: center;
    ${mixinRobotoRegular}
  }

  .vppa-details-wrapper .row > * {
    display: tabular-cell;
    width: 50%;
  }

  .vppa-details-wrapper .row span:first-child {
    color: var(--gray-lighter);
    ${mixinRobotoBold}
  }

  .vppa-details-wrapper .row span:second-child {
    width: 120px;
  }

  .add-rfq {
    width: 410px;
    padding: 15px;
    overflow: auto;
    max-height: calc(100% - 45px);
  }

  .button-wrapper {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }
`;
